

export class Age{

  key : string;
  parent : number;
  low : number;
  high : number;
  childs : [number];
  childsVisible : boolean;

}



// WEBPACK FOOTER //
// ./src/app/classes/age.ts